import React, { ReactNode } from 'react';
import { ValidationMessageStyled, ValidationMessageTagStyled } from './ValidationSummary.styles';

export interface IValidationMessage {
  valid: boolean;
  message: ReactNode;
}

/*tslint:disable-next-line:variable-name*/
const ValidationMessage = ({ message, valid }: IValidationMessage) => (
  <ValidationMessageStyled>
    <ValidationMessageTagStyled isValid={valid}>{valid ? 'VALID' : 'ERROR'}</ValidationMessageTagStyled>
    <span>{message}</span>
  </ValidationMessageStyled>
);

export default ValidationMessage;
